module.exports = __webpack_public_path__ + "static/CaviarDreams_Italic-webfont-abf751fd6d37a19678d5011fec67944c.woff";